import { Injectable, inject } from '@angular/core';
import { CanActivate } from '@angular/router';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { MultilanguageService } from '@plugins/client/multilanguage/multilanguage.service';

import { DataService } from '../services';

/**
 * Loads the instance before the route activates and hands the activated
 * languages to the multilanguage service.
 */
@Injectable({ providedIn: 'root' })
export class InstanceGuard implements CanActivate {
  private readonly dataService = inject(DataService);
  private readonly multilanguageService = inject(MultilanguageService);

  canActivate() {
    return of(this.dataService.instance).pipe(
      switchMap((instance) =>
        instance ? of(instance) : this.dataService.fetchInstance(),
      ),
      map((instance) => {
        this.multilanguageService.setLimitedLanguages(instance.languages);
        return true;
      }),
    );
  }
}
